import React, { useEffect, useState, useContext } from 'react';
import Layout from '../Components/Dashboard/Layout';
import Card from '../Components/Dashboard/Card';
import Table from '../Components/Dashboard/TableComponent';
import { DashboardChart } from './Charts/dashboard/deals/DealsChart';
import whatsAppImagePath from '../src/assets/popup.png';
import ActivateBtnImg from '../src/assets/popupActivate.png';
import { WhatsappUser } from '../Config/config';
import axios from 'axios';
import { UserContext } from '../Contexts/UserContext';

function Dashboard() {
    const [showInitialPopup, setShowInitialPopup] = useState(false);
    const [showMobileInputPopup, setShowMobileInputPopup] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('');
    const [designation, setDesignation] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { getToken } = useContext(UserContext);

    useEffect(() => {
        const popupCount = parseInt(localStorage.getItem('showPopupCount')) || parseInt(localStorage.getItem('popup_show_count')) || 0;
        if (popupCount <= 2) {
            setShowInitialPopup(true);
        }
    }, []);

    const title = "Dashboard - Venture Intelligence";
    document.title = title;

    const handleActivate = () => {
        setShowInitialPopup(false);
        setShowMobileInputPopup(true);
    };

    const handleSaveMobile = async () => {
        try {
            setErrorMessage(''); // Clear previous errors
            const payload = {
                whatsapp_number: `91${mobileNumber}`,
                user_designation: designation.trim()
            };

            await axios.post(WhatsappUser, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": getToken()
                }
            });

            setShowMobileInputPopup(false);
            setShowConfirmation(true);
            localStorage.setItem('showPopupCount', '3');

            setTimeout(() => {
                setShowConfirmation(false);
            }, 3000);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage("Something went wrong. Please try again.");
            }
            console.error("Failed to send WhatsApp user data:", error);
        }
    };

    const closeAllPopups = () => {
        setShowInitialPopup(false);
        setShowMobileInputPopup(false);
        setShowConfirmation(false);
        setErrorMessage('');
        localStorage.setItem('showPopupCount', '3');
    };

    return (
        <div className={`bg-white relative ${showInitialPopup || showMobileInputPopup || showConfirmation ? 'overflow-hidden' : ''}`}>
            {(showInitialPopup || showMobileInputPopup || showConfirmation) && (
                <div className="fixed inset-0 mt-12 bg-black bg-opacity-50 z-50 flex items-center justify-center backdrop-blur-sm">
                    <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-5 animate-fadeIn transition-all">

                        {/* Initial Popup */}
                        {showInitialPopup && !showMobileInputPopup && !showConfirmation && (
                            <>
                                <button
                                    onClick={closeAllPopups}
                                    className="absolute -top-1 right-3 text-gray-500 hover:text-red-500 text-2xl"
                                    aria-label="Close"
                                >
                                    &times;
                                </button>

                                <img
                                    src={whatsAppImagePath}
                                    alt="Survey popup"
                                    className="w-full h-auto object-contain"
                                />
                                <div className="flex justify-center mt-5">
                                    <img
                                        src={ActivateBtnImg}
                                        alt="Activate Now"
                                        onClick={handleActivate}
                                        className="cursor-pointer hover:scale-105 transition-transform duration-200"
                                        style={{ width: '180px' }}
                                    />
                                </div>
                            </>
                        )}

                        {/* Mobile Input Popup */}
                        {showMobileInputPopup && (
                            <div className="space-y-4">
                                <button
                                    onClick={closeAllPopups}
                                    className="absolute top-[1px] right-3 text-gray-500 hover:text-red-500 text-2xl"
                                    aria-label="Close"
                                >
                                    &times;
                                </button>

                                <h2 className="text-lg font-semibold text-gray-700">Add your WhatsApp number</h2>

                                <div className="flex items-center border px-3 py-2 rounded-md focus-within:ring-2 focus-within:ring-blue-500">
                                    <span className="text-gray-500 mr-2 select-none">+91 |</span>
                                    <input
                                        type="tel"
                                        maxLength={10}
                                        value={mobileNumber}
                                        onChange={(e) => {
                                            const input = e.target.value.replace(/\D/g, '');
                                            if (input.length <= 10) {
                                                setMobileNumber(input);
                                            }
                                        }}
                                        placeholder="Enter 10-digit number"
                                        className="flex-1 outline-none"
                                    />
                                </div>

                                <input
                                    type="text"
                                    value={designation}
                                    onChange={(e) => setDesignation(e.target.value)}
                                    placeholder="Enter your designation"
                                    className="w-full border px-3 py-2 rounded-md outline-none focus:ring-2 focus:ring-blue-500"
                                />

                                {errorMessage && (
                                    <div className="text-red-600 text-sm mt-1">{errorMessage}</div>
                                )}

                                <button
                                    onClick={handleSaveMobile}
                                    className={`${
                                        mobileNumber.length === 10 && designation.trim() !== ''
                                            ? 'bg-[#BC8B20] hover:bg-[#e7c067]'
                                            : 'bg-gray-400 cursor-not-allowed'
                                    } text-white px-4 py-2 rounded-md w-full transition-colors duration-200`}
                                    disabled={mobileNumber.length !== 10 || designation.trim() === ''}
                                >
                                    Save
                                </button>
                            </div>
                        )}

                        {/* Confirmation Message */}
                        {showConfirmation && (
                            <div className="text-center text-lg font-medium text-green-600">
                                Thank you! We will notify you via email.
                            </div>
                        )}
                    </div>
                </div>
            )}

            <Layout>
                <Card />
                <Table />
                <div className='p-2 w-[100%] bg-[#EDEDED]'>
                    <DashboardChart dataColors='["#474747", "#BC8B20"]' />
                </div>
            </Layout>
        </div>
    );
}

export default Dashboard;
